import { forwardRef } from 'react';
const Div = forwardRef((props, ref) => {
    const { style, dynamicStyle, ...otherProps } = props;
    const mergeStyle = { ...style, ...dynamicStyle };
    return React.createElement("div", Object.assign({ style: mergeStyle }, otherProps, { ref: ref }));
});
Div.displayName = 'AMDiv';
export default Div;
